<template>
    <div class="receipt-wrap">
        <div class="user-page-wrap">
            <img class="avatar" :src="userInfo.avatar" alt="">
            <div class="info-wrap">
                <div  class="username">
                    <span>{{userInfo.username|| userInfo.mobile || ''}}</span>
                    <!-- 立即开通 -->
                     
                    <div class="buy" v-if="userInfo && userInfo.cycle && userInfo.cycle.end_time" @click="buy">{{$t('renew')}}</div>

                    <div class="buy" v-else @click="buy">{{$t('opened')}}</div>
                </div>     

                <div class="desc" v-if="userInfo && userInfo.cycle && userInfo.cycle.end_time">{{$t('videoEnd')}}{{userInfo.cycle.end_time}}</div>
                <div class="desc" v-else>{{$t('vipTips')}}</div>
            </div>
        </div>

        <template v-if="listArr.length  > 0">   
            <el-table :data="listArr"  border style="width: 100%">
                <el-table-column  prop="ctime"  :label="$t('date')"  width="180"> </el-table-column>
                <el-table-column  prop="title" :label="$t('type')" width="180"> </el-table-column>
                <el-table-column  prop="payed" :label="$t('money')"> </el-table-column> 
                <el-table-column :label="$t('payment')">
                    <template slot-scope="scope">
                        {{payCode[scope.row.pay_code]}}
                        <!-- <div>{{pageCode[scope.row.pay_code]}}</div> -->
                    </template>
                </el-table-column>
                <!-- <el-table-column  prop="pay_code" :label="$t('payment')"> </el-table-column> -->
            </el-table>
        </template>
        <div v-else>{{$t('noData')}}</div>
        <div>
            <template v-if="listArr.length>0">
                <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
            </template>
        </div>



         <div class="dia-pay-wrap">
        <el-dialog :visible="dialog" >
          <div class="dia-top-pic-wrap">
            <div class="info">
              <img  v-if="userInfo.avatar" :src="userInfo.avatar "  class="avatar" alt="">
              <img class="avatar"   v-else src="../../assets/images/avatar-default.png"  alt="">
              <div class="user">
                <div class="user-name">{{userInfo.username || userInfo.mobile || ''}}</div>
                <div class="desc" v-if="userInfo && userInfo.cycle && userInfo.cycle.end_time">{{userInfo.cycle.end_time}}</div>
                <div class="desc" v-else>{{$t('vipTips')}}</div>
              </div>
              <img class="close-dig" src="../../assets/images/video/close-b.png" alt="" @click="dialog = false">
            </div>
          </div>
          <div class="dia-wrap"> 
 
            <div class="card-wrap">
              <div class="card-item" v-for="(item, index) in cardlist" :key="item.id" @click="selectPic(item, index)">
                <img class="pic"  :src="cardCurrent == item.id ? require('@/assets/images/arrow/card-h.png') : require('@/assets/images/arrow/card.png')" alt="">
                <div class="title">{{item.name}}</div>
                <div class="price">{{$t('currencySymbol')}} {{item.price}}</div>
              </div>
            </div>

            <div class="pay-wrap">
                <!-- 选择支付 -->
              <div class="title">{{$t('chooseToPay')}}</div>
              <div class="pay-list">
                <div class="pay-item">
                  <el-radio-group v-model="payType">
                    <el-radio :label="item.code" v-for="(item,index) in payments" :key="index">
                      <span class="pay-type" :class="{'active':payType==item.code}">
                        <i class="icon iconfont iconxianxiamendian" v-if="item.code=='offline'"></i>
                        <i class="icon iconfont iconyuezhifu" v-else-if="item.code=='balancepay'"></i>
                        <i class="icon iconfont iconzhifubao" v-else-if="item.code=='alipay'"></i>
                        <i class="icon iconfont iconweixinzhifu" v-else-if="item.code=='wechatpay'"></i>
                        {{item.name}}
                      </span>
                    </el-radio>
                  </el-radio-group>
                </div>
                <div class="pay-action">
                    <span v-if="cardlist[cardIndex]" class="price">{{$t('currencySymbol')}}{{cardlist[cardIndex].price}}</span>  
                    <el-button :loading="btnLoading" type="" @click="buyVideo">{{$t('toPay')}}</el-button>
                </div>
              </div>
            </div>

            <div> 
              <router-link to="/">《{{$t('tipsType.vip')}}》</router-link>
            </div>
          </div>
        </el-dialog>
        </div>


        <template v-if="dialogPaymentShow">
          <Payment :codeImg="code_url" @clearInterPay="clearInterPay"></Payment>
        </template>
    </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
import Payment from "@/components/payment.vue";
import { locationHost } from "@/config/env.js";

export default {
    components: { Pagination, Payment },
    data() {
        return{
            listArr: [],
            page: 1,
            limit: 10,
            totalPage: 0,
            userInfo: {},
            dialogPaymentShow: false,
            code_url: '',
            dialog: false,
            cardlist: [],
            payType: "alipay",
            payments: [],
            cardIndex: 0,
            cardCurrent: 0,
            btnLoading: false,
            payCode: {
                balancepay: this.$t('balancepay'),
                wechatpay: this.$t('wechatpay'),
                alipay: this.$t('alipay')
            }
        }
    },
    mounted() {
        this.init()
        this.card()
        this.getPaymentType();
        this.$api.userInfo().then(result => {
            if (result.status) {
                this.userInfo = result.data
            }
        });
    },
    methods: {
        // 获取支付方式
        getPaymentType() {
            this.$api.paymentList().then(res => {
            let data = res.data;
            this.payments = data;
            });
        },
        // 选择卡片
        selectPic(val, index) {
            this.cardCurrent = val.id
            this.cardIndex = index
        },
        // 会员卡
        card() {
            this.$api.getcoursecard().then(res => {
            if(res.status) {
                this.cardlist = this.cardlist.concat(res.data.list)
                this.cardCurrent = res.data.list[0].id
            }
            })
        },

        // 购买视频
        buyVideo(){
            // if()
            let data = {
                course_id:  this.cardCurrent,
                payment_type:  2, // 1视频 2 视频卡
                payment_code: this.payType,
                source: '1'
            }
            this.$api.coursepay(data).then( res => {
            if(res.status) {
                this.createAction(res.data.order_id)
            }
            })
        },
        buy() {
            this.dialog = true
        },
        init() {
            this.$api.courseGetorderlist(
                {
                    page: this.page,
                    limit: this.limit
                }
            ).then(res => {
                this.totalPage = Math.ceil(
                    Number(res.data.count) / Number(this.limit)
                );
                this.listArr = res.data.list
			});
        },
        //分页加载
        handOrderMore(val) {
            this.page = val;
            this.init();
        },
        // 清除定时器
        clearInterPay() {
            clearInterval(this.intervalPayStatus);
            this.dialogPaymentShow = false;
            this.btnLoading = false
        },

        // 创建视频订单
      createAction(ids) {
        this.btnLoading = true;
        let code = this.payType;
        if(code == 'wechatpay') {

          let data = {
            ids,
            payment_code: this.payType,
            payment_type:  4, //  3=视频 4=视频卡
            params: {
              trade_type: "NATIVE"
            }
          }
          this.$api.pay(data).then(res => {
            this.$message({
              message: res.msg,
              type: 'warning'
            })
            if(res.status) {
              this.code_url = res.data.code_url;
              this.dialogPaymentShow = true
              this.getPaymentStatus(res.data.payment_id);
            }
          })
        } else if (code == "alipay") {
          let data = {
            ids,
            payment_code: this.payType,
            payment_type: 4, //  3=视频 4=视频卡
            params: {
              trade_type: "PC",
              return_url:
                locationHost+ "/cashier/" + ids
            }
          };

          this.$api.pay(data).then(res => {
            this.btnLoading = false;
            if (res.status) {
              this.standarPost(res.data.url, res.data.data);
            }
          }).catch(() => {
              this.btnLoading = false;
          });
        } else if (code == "balancepay") {
          // 余额支付
          let data = {
            ids,
            payment_code: this.payType,
            payment_type:  4, //  3=视频 4=视频卡
          };
          this.$api.pay(data).then(res => {
              this.btnLoading = false;
            if (res.status && res.msg == this.$t('paySucess')) {
              this.$msg(this.$t('paySucess'));
              // this.toPaySuccess();
              this.dialog = false
              this.init()
            } else {
              this.$msg(res.msg, "warning");
            }
          }).catch(() => {
              this.btnLoading = false;
          });
        } else if (code == "offline") {
          this.$confirm(this.$t('paymentofflineTitle'), this.$t('offlineExplain'), {
            confirmButtonText: this.$t('orderDetail'),
            cancelButtonText: this.$t('next'),
            type: "info"
          })
            .then(() => {
              this.btnLoading = false;
              this.$router.replace({
                name: "orderDetail",
                params: { order_id: ids }
              });
            })
            .catch(() => {
              this.btnLoading = false;
              // this.$router.replace({ name: "home" });
            });
        } else if(code == 'paypal') {
          let data = {
            ids,
            payment_code: this.payType,
            payment_type:  4, //  3=视频 4=视频卡
            params: {
              trade_type: "PC",
              return_url:
                locationHost+ "/cashier/" + ids
            }
          };
          this.$api.pay(data).then(res => {
              this.btnLoading = false;
            if (res.status) {
              // this.$msg(this.$t('paySucess'));
              // this.toPaySuccess();
              // window.open(res.data.url, '_blank')
              window.location.href = res.data.url

              this.dialog = false
              this.init()
            } else {
              this.$msg(res.msg, "warning");
            }
          }).catch(() => {
              this.btnLoading = false;
          });
        }
      },
      // 支付宝支付后
      standarPost(url, data) {
        let tempForm = document.createElement("form");
        tempForm.id = "aliPay";
        tempForm.methods = "post";
        tempForm.action = url;
        tempForm.target = "_self";
        let input = [];
        for (let k in data) {
          input[k] = document.createElement("input");
          input[k].type = "hidden";
          input[k].name = k;
          input[k].value = data[k];
          tempForm.appendChild(input[k]);
        }
        tempForm.addEventListener("submit", function() {}, false);
        document.body.appendChild(tempForm);
        tempForm.dispatchEvent(new Event("submit"));
        tempForm.submit();
        document.body.removeChild(tempForm);
      },
      getPaymentStatus(id) {
        let data = {
          payment_id: id
        };
        let that = this;
        this.intervalPayStatus = setInterval(function() {
          that.$api.paymentInfo(data).then(res => {
            if (res.status) {
              if (res.data.status == 2) {
                that.$msg(this.$t('paySucess'));
                that.dialogPaymentShow = false;
                that.dialog = false
                that.init()
              }
            }
          });
        }, 1000);
      }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.user-page-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 20px;
        
    }
    .info-wrap {
        .username {
            color: #e7442f;
            font-size: 20px;
            display: flex;
            align-items: center;
            .buy {
                margin-left: 300px;
                background: #00a1d6;
                border-radius: 4px;
                font-size: 14px;
                color: #fff;
                cursor: pointer;
                line-height: 14px;
                padding: 9px 8px;
            }
        }
        .desc {
            font-size: 12px;
            color: #99a2aa;
            line-height: 12px;
        }
    }
}
.mgb10 {
    margin-bottom: 10px;
}
.over-ell {
    width: 180px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.receipt-wrap {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
}
.receipt-item {
    background: linear-gradient(to right, #ff6565, #ff8a8a);
    color: #fff;
    display: flex;
    padding: 20px 20px 20px 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    img {
        width: 69px;
        height: 72px;
        margin-right: 10px;
    }
    .amount {
        span {
            font-size: 18px;
        }
    }
}


.pay-wrap {
  border: 1px solid #999999;
  padding: 13px 20px;
  margin: 10px 0;
  font-weight: bold;
  height: 200px;
  position: relative;
  .title {
    margin-bottom: 20px;
    color: #333333;
    font-size: 18px;
  }
  .pay-list {
    .pay-type {
      display: inline-block;
      width: 130px;
      height: 36px;
      line-height: 32px;
      text-align: center;
      border: 1px solid $border;
      transition: all 0.2s;
      cursor: pointer;
      padding: 1px;
      box-sizing: border-box;
      &.active,
      &:hover {
        border-color: $theme-color;
      }
    }
    .pay-action {
      position: absolute;
      bottom: 20px;
      right: 20px;
      margin-top: 50px;
      color: #999999;
      font-size: 14px;
      .price {
        color: #EA4B49;
        font-size: 18px;
        margin-right: 20px;
      }
      .el-button {
        background: #EA4B49;
        border: none;
        color: #fff;
      }
    }
  }
}


.brief {
  padding: 10px 0;
  line-height: 24px;
}
.dia-top-pic-wrap {
  width: 100%;
  height: 140px;
  position: relative;
  background: url('~@/assets/images/video/dia-bg.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  .info {
    display: flex;
    align-items: center;
    .avatar {
      width: 66px;
      height: 66px;
      border-radius: 50%;
      margin-right: 20px;
    }
    .user-name {
      color: #95673A;
      font-size: 16px;
    //   margin-bottom: 10px;
    }
    .desc {
        margin-top: 10px;
        opacity: 0.6;
        font-size: 14px;
        color: #95673A;
    }
  }
  .close-dig{
    position: absolute;
    right: 40px;
    top: 50px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}
.dia-wrap {
  padding:  20px;
  
  .card-wrap {
    display: flex;
    .card-item {
      position: relative;
      margin-right: 20px;
      width: 135px;
      height: 180px;
      cursor: pointer;
      .pic {
        position: absolute;
        width: 100%;
        height: 100%;
      }
      div {
        position: relative;
        text-align: center;
        &.title {
          color:#166288;
          font-size: 14px;
          margin: 20px 0;
        }
        &.price {
          margin-top: 10px;
          color: #E7442F;
          font-size: 22px;
          font-weight: bold;
        }
      }
    }
  }
}
.video-list {
  &-item {
    display: flex;
    flex-wrap: wrap;
    .link {
      width: 190px;
      color: #595959;
      overflow: hidden;
      margin-right: 30px;
      margin-bottom: 10px;
      cursor: pointer;
      &:nth-child(4n) {
        margin-right: 0;
      }
      .title {
        overflow: hidden;
        word-break: break-all;
        word-wrap: break-word;
        height: 28px;
        @include no-wrap-line(2);
      }
      .img-wrap {
        position: relative;
        width: 190px;
        height: 114px;
        margin-bottom: 5px;
        overflow: hidden;
        img {
          width: 190px;
          height: 114px;
          display: block;
          margin: 0 0 12px;
          border-radius: 5px;
        }
      }
      .palynums {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        color: #fff;
        font-size: 12px;
        z-index: 10;
        overflow: hidden;
        height: 20px;
        width: 100%;
        background: rgba(0,0,0,.3);
        display: flex;
        align-items: center;
        span {
          display: inline-block;
          overflow: hidden;
          width: 13px;
          height: 12px;
          margin-right: 3px;
          line-height: 999em;
          vertical-align: -2px;
          margin-left: 8px;
          background: url('http://www.sanlida.cn/Templates/master/sanlida/images/video_pic.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      
    }
  }
}

.tabs {
  position: relative;
  &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #E4E7ED;
      z-index: 1;
  }
  .item {
      // padding: 0 20px;
      height: 40px;
      box-sizing: border-box;
      line-height: 40px;
      display: inline-block;
      list-style: none;
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      position: relative;
      border-bottom: 2px solid #EA4B49;
      z-index: 2;
      &.active {
          color: #EA4B49;
      }
      &:first-child {
          padding-left: 0;
      }
  }
}
.nav {
  @include line-height(40px);
  font-size: 12px;
  span {
    padding: 0 4px;
    font-size: #757575;
  }
  a:hover {
    color: #000;
  }
}
    .rmtj {
        &-list {
            &-item {
                position: relative;
                width: 100%;
                height: 130px;
                overflow: hidden;
                border-bottom: 1px solid #eee;
                padding: 21px 0;
                &:last-child {
                    border: none;
                }
                .side {
                    bottom: 21px;
                    width: 627px;
                    height: 24px;
                    box-sizing: border-box;
                    float: left;
                    font-size: 14px;
                    line-height: 24px;
                    color: #999;
                    .tag {
                        margin-right: 20px;
                        float: left;
                        span{
                            float: left;
                            margin: 0;
                        }
                    }
                }
                .img-link {
                    position: relative;
                    float: left;
                    width: 190px;
                    height: 127px;
                    overflow: hidden;
                    border-radius: 6px;
                    margin-right: 20px;
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
                .well {
                        height: 100px;
                        .title {
                            height: 26px;
                            overflow: hidden;
                            font-size: 18px;
                            font-weight: 700;
                            line-height: 26px;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            color: #333;
                        }
                        .des {
                            height: 52px;
                            margin-top: 6px;
                            overflow: hidden;
                            font-size: 16px;
                            line-height: 26px;
                            color: #595959;
                        }
                }
            }
        }
    }
    .tabs {
        position: relative;
        &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px;
            background-color: #E4E7ED;
            z-index: 1;
        }
        .item {
            // padding: 0 20px;
            height: 40px;
            box-sizing: border-box;
            line-height: 40px;
            display: inline-block;
            list-style: none;
            font-size: 14px;
            font-weight: 500;
            color: #303133;
            position: relative;
            border-bottom: 2px solid #EA4B49;
            z-index: 2;
            &.active {
                color: #EA4B49;
            }
            &:first-child {
                padding-left: 0;
            }
        }
    }
    .article {
        &-left {
            width: 900px;
            float: left;
            margin-bottom: 30px;
            .video-wrap {
              background: #fff;
              padding: 20px;
              border-radius: 6px;
            }
            .other-video {
              margin-top: 20px;
              background: #fff;
              padding: 20px;
              border-radius: 6px;
            }
            .replay-action {
              margin-top: 20px;
              background: #fff;
              padding: 20px;
              border-radius: 6px;
              float: left;
              width: 100%;
              box-sizing: border-box;
              .el-textarea {
                margin-bottom: 20px;
              }
              .comment-list-item {
                border: none !important;
              }
            }
            .comment-list {
              margin-top: 20px;
              background: #fff;
              padding: 20px;
              border-radius: 6px;
              padding-bottom: 80px;
              float: left;
              width: 100%;
              box-sizing: border-box;
              .none-comment {
                font-size: 18px;
                color: #333;
              }
              &-item {
                position: relative;
                margin-top: 20px;
                padding-bottom: 20px;
                border-bottom: 1px solid #e6e6e6;
                float: left;
                width: 100%;
                .reply_list_img {
                  float: left;
                  img {
                    width: 50px;
                    height: 50px;
                    display: block;
                    border-radius: 50%;
                  }
                }
                .reply_list_con {
                  width: 780px;
                  float: right;
                  position: relative;
                  // margin-left: 20px;
                  .auth_msg {
                    line-height: 20px;
                    font-size: 12px;
                    color: #8c8c8c;
                    i {
                      margin-right: 5px;
                      font-size: 14px;
                      color: #ff8b3d;
                    }
                  }
                  .reply_txt {
                    overflow: hidden;
                    font-size: 16px;
                    margin-top: 5px;
                  }
                }
              }
            }
            .jxdd {
                width: 100%;
                float: left;
                margin-bottom: 20px;
                .ad {
                    &-item {
                        float: left;
                        width: 264px;
                        margin-right: 20px;
                        border: 1px solid #eee;
                        margin-top: 20px;
                        box-sizing: border-box;
                        &:nth-child(3n) {
                            margin-right: 0;
                        }
                        img {
                            width: 264px;
                            height: 154px;
                        }
                        h3 {
                            height: 39px;
                            overflow: hidden;
                            padding: 10px 15px 15px 15px;
                            .link {
                                width: 100%;
                                height: 39px;
                                float: left;
                                line-height: 22px;
                                overflow: hidden;
                                font-size: 14px;
                                font-weight: normal;
                                
                            }
                        }
                    }
                }
            }

        }
        &-right {
            width: 300px;
            float: right;
            border-radius: 6px;
            font-size: 14px;
            .box {
                width: 260px;
                margin-bottom: 10px;
                padding: 0 20px;
                background: #fff;
                border-radius: 5px;
                h4 {
                    width: 300px;
                    margin-left: -20px;
                    height: 40px;
                    line-height: 40px;
                    border-bottom: 1px solid #e8e8e8;
                    border-radius: 5px 5px 0 0;
                    background: #ffffff;
                    background: linear-gradient(top, #ffffff, #f7f7f7);
                    strong {
                        display: block;
                        width: 122px;
                        margin-left: 15px;
                        color: #434a54;
                        font-weight: bold;
                        font-size: 14px;
                    }
                    .link {
                        float: right;
                        margin: -40px 20px 0 0;
                        color: #667ebd;
                        font-size: 12px;
                        
                    }
                }
                &.hot {
                    overflow: hidden;
                    ul {
                        width: 302px;
                        margin-left: -20px;
                        overflow: auto;
                        
                        li {
                            float: left;
                            width: 150px;
                            height: 45px;
                            line-height: 45px;
                            border-bottom: 1px solid #eee;
                            border-right: 1px solid #eee;
                            background: #ffffff;
                            text-align: center;
                            &:hover {
                                color: #EA4B49;
                            }
                            &.more {
                                width: 300px;
                                float: left;
                                height: 45px;
                                line-height: 45px;
                                border-bottom: 1px solid #eee;
                                border-right: 1px solid #eee;
                                background: #ffffff;
                                text-align: center;
                                cursor: pointer;
                            }
                        }
                    }
                }
                &.choice{
                    .article {
                        line-height: 24px;
                        margin: 0 0 0 24px;
                        padding: 10px 0;
                        li {
                            padding: 4px 0 5px;
                            em {
                                float: left;
                                width: 14px;
                                height: 14px;
                                line-height: 14px;
                                margin: 3px 0 0 -24px;
                                border: 2px solid #aab2bd;
                                border-radius: 50%;
                                color: #aab2bd;
                                font-family: Tahoma,Verdana,sans-serif;
                                font-size: 10px;
                                text-align: center;
                                &.active {
                                    border: 2px solid #ff6600;
                                    color: #ff6600;
                                }
                            }
                            .link {
                                color: #595959;
                                overflow: hidden;
                               
                            }
                        }
                    }
                }
                &.academy {
                    ul {
                        margin-top: 20px;
                        margin-left: -10px;
                        // overflow: auto;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        li {
                            float: left;
                            width: 125px;
                            height: 145px;
                            line-height: 18px;
                            margin-left: 10px;
                            cursor: pointer;
                            .link {
                                color: #595959;
                                overflow: hidden;
                                position: relative;
                                .palynums {
                                  position: absolute;
                                  top: 66px;
                                  left: 0;
                                  width: 100%;
                                  color: #fff;
                                  font-size: 12px;
                                  z-index: 10;
                                  span {
                                    display: inline-block;
                                    overflow: hidden;
                                    width: 13px;
                                    height: 12px;
                                    margin-right: 3px;
                                    line-height: 999em;
                                    vertical-align: -2px;
                                    margin-left: 8px;
                                    background: url('http://www.sanlida.cn/Templates/master/sanlida/images/video_pic.png') no-repeat;
                                    background-size: 100% 100%;
                                  }
                                }
                                img {
                                  width: 125px;
                                  height: 85px;
                                  display: block;
                                  margin: 0 0 12px;
                                  border-radius: 5px;
                                }
                                .img-bg {
                                  width: 125px;
                                  height: 85px;
                                  display: block;
                                  margin: 0 0 12px;
                                  border-radius: 5px;
                                }
                                .title {
                                  @include no-wrap-line(2)
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .player-wrap {
      width: 100%;
      height: 480px;
      .video-place {
        position: relative;
        width: 100%;
        height: 100%;
        background: #091B26;
        .logo {
          position: absolute;
          top: 20px;
          left: 20px;
        }
        .arrow {
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .btn-wrap {
          position: absolute;
          top: 66%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: flex;
          align-items: center;
          justify-content: center;
          .btn-item {
            padding: 0 14px;
            cursor: pointer;
            height: 50px;
            border-radius: 4px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 20px;
            border: none;
            &.btn-01 {
              background: #E7442F;
            }
            // &.btn-02 {
            //   background: #339AD9;
            // }
            // &:first-child {
            //   margin-right: 30px;
            // }
          }
        }
      }
    }


</style>>

<style >

.dia-pay-wrap .el-dialog {
  border-radius: 24px;
}

.dia-pay-wrap .el-dialog__header {
  display: none !important;
}
.el-radio {
  margin-bottom: 10px;
}
</style>